//****** Remplazar dato o simbolo o algo *********\\
export const ReplaceCharacter = (namesxd: string): string => {
  return namesxd.split("-").join(" ");
};

export const ReplaceCharacterRest = (namesxd: string): string => {
  return namesxd.split(" ").join("-");
};

export const ReplaceCharacterOneUpperCase = (namesxd: string): string => {
  const texto = namesxd.toLocaleLowerCase();
  return texto.charAt(0).toUpperCase() + texto.slice(1);
}

